"use client"
import { INITIAL_LOCALE, INITIAL_LOCALES } from "@/libs/constants"
import {handleHrefChangeLocaleS } from "@/libs/functions"
import clsx from "clsx"
import Link from "next/link"
import { usePathname } from "next/navigation"
import React from "react"

const LinkedOne: React.FC<{ locale: string, item: string }> = ({ item, locale }) => {
    const pathname = usePathname()

    return (
        <p className={"linked__one cursor-pointer d-flex justify-content-center my-auto"}>
            <Link href={handleHrefChangeLocaleS(locale, item, pathname)}
                passHref
                target="_self"
                className={clsx("text-uppercase text-decoration-none",
                    locale === item ? "disabled" : "")}>
                {item}
            </Link>
        </p>
    )
}
interface UnderAttackLocaleProps {
    locale: string
}

const UnderAttackLocale: React.FC<UnderAttackLocaleProps> = ({
    locale = 'vi-VN'
}) => {

    const [locales, _] = React.useState<Array<string>>(INITIAL_LOCALES)

    const [show, setShow] = React.useState(false)
    const handlerClose = () => setShow(false)

    return (
        <div className="under__attack__selector"
            onClick={() => setShow(!show)}
            onMouseLeave={handlerClose}
        >
            <div className={clsx("linked bg-lavender", show ? "toggle__on" : "")}
                onMouseLeave={handlerClose}>
                {locales.length > 1 && locales?.map((item: string, index: number) => {
                    return (
                        <LinkedOne item={item} key={index} locale={locale} />
                    )
                })}
            </div>
            <div className={clsx("d-flex justify-content-center bg-white selected", show ? "toggle__on" : "")}>
                <span className={clsx("my-auto text-uppercase cursor-pointer")}>
                    {locale.split("-")[0]}
                </span>
            </div>
        </div>
    )
}
export default UnderAttackLocale